export const environment = {
  production: false,
  apiUrl: 'https://api.studentformsadmin-test.athabascau.ca',
  envName: 'TESTING',

  // TODO: reuse the dev cognito pool for now until the testing app added to Microsoft.

  // test
  // authority: 'https://cognito-idp.us-west-2.amazonaws.com/us-west-2_ZwJ7q4EHf',
  // clientId: '17rcu640j8r7jbvht92v7ubt3r',

  // dev
  authority: 'https://cognito-idp.us-west-2.amazonaws.com/us-west-2_NDJWFeX1P',
  clientId: '4v57bjuhrqnps0mg237ktsqq5r',

  scope: 'email openid profile',
  responseType: 'code',
};
